import { Fragment } from 'react'
import type { ReactNode } from 'react'
import { cn } from '@/lib/cn'
import styles from './TabBar.module.css'

export type TabBarItem = {
  id: string
  active: boolean
  render: (props: { className: string; children: ReactNode; 'aria-current': 'page' | undefined }) => ReactNode
  icon: ReactNode
  label: string
}

// Customer's presentation; routing and product tabs are supplied by the app.
export function TabBar({ items }: { items: readonly TabBarItem[] }) {
  return <nav className={styles.tabBar} aria-label="ناوبری اصلی">
    {items.map(item => <Fragment key={item.id}>
      {item.render({
        className: cn(styles.tab, { [styles.tabActive]: item.active }),
        'aria-current': item.active ? 'page' : undefined,
        children: <><span className={styles.tabIcon}>{item.icon}</span><span className={styles.tabLabel}>{item.label}</span></>,
      })}
    </Fragment>)}
  </nav>
}
